import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgHorizontalSliderOn = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M16.5 5.75a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5m-3.163 1a3.251 3.251 0 1 1 0 1.5H5a.75.75 0 0 1 0-1.5zm-2.337 8a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5m-3.163 1a3.251 3.251 0 0 1 6.326 0H19a.75.75 0 0 1 0 1.5h-4.837a3.251 3.251 0 0 1-6.326 0H5a.75.75 0 0 1 0-1.5z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgHorizontalSliderOn;
